import { ProgramBroadcastFiltersState } from '@/stores/program-broadcast-filters';

export type TAppliedFilterValues = Pick<
  ProgramBroadcastFiltersState,
  | 'review_states'
  | 'broadcasters'
  | 'workspaces'
  | 'projects'
  | 'tags'
  | 'programs'
  | 'logos'
  | 'people'
>;

export function hasAppliedFilters(values: TAppliedFilterValues): boolean {
  return [
    values.review_states,
    values.broadcasters,
    values.workspaces,
    values.projects,
    values.tags,
    values.programs,
    values.logos,
    values.people,
  ].some(list => list.length > 0);
}
